const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
const ADMIN_TOKEN_KEY = "my-car-admin-token";

export function getAdminToken() {
  return window.localStorage.getItem(ADMIN_TOKEN_KEY);
}

export function isAdminAuthenticated() {
  return Boolean(getAdminToken());
}

export function logoutAdmin() {
  window.localStorage.removeItem(ADMIN_TOKEN_KEY);
}

export async function validateAdminSession() {
  const response = await fetch(`${API_URL}/auth/me`, {
    headers: adminHeaders(),
  });
  return response.ok;
}

export async function loginAdmin(username, password) {
  const response = await fetch(`${API_URL}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.message || "Unable to sign in.");
  }

  window.localStorage.setItem(ADMIN_TOKEN_KEY, data.token);
  return data;
}

export function adminHeaders() {
  const token = getAdminToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
